import React from 'react';

import {
    Button,
    Box,
    Typography,
    Container,
} from "@mui/material";

import AddStudentsTable from './AddStudentsTable';

const ClassWizardEnd = ({ addMethod, userInput, students, setStudents, handleCreate, isCreating, errorMessage }) => {

    return (
        <Box sx={{ textAlign: 'center', p: addMethod === 'later' ? 12 : 4 }}>

            <Typography variant="h5">{addMethod === 'manual' ? 'Add Students Manually' : 'Review'}</Typography>
            <Typography variant="body1" sx={{ mb: 3, pl: '100px', pr: '100px' }}>{
                addMethod === 'manual' ? "Fill out the fields below. Click the + sign to add more." :
                addMethod === 'upload' ? "Review the class information and list of students." :
                "Review the class information."
            }</Typography>

            <Container
                component="main"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    my: addMethod === 'later' ? 8 : 1,
                }}
            >
                    <Box sx={{
                        textAlign: 'left',
                        display: 'flex',
                        flexDirection: 'column',
                        textTransform: 'uppercase',
                        minWidth: '230px' }}
                    >
                        <Typography>Class Name: {userInput.name}</Typography>
                        <Typography>Class Level: {userInput.level ? userInput.level : '—'}</Typography>
                        <Typography>Academic Term: {userInput.term ? userInput.term : '—'}</Typography>
                    </Box>
            </Container>

            { addMethod !== 'later' &&
                <AddStudentsTable
                    addMethod={addMethod}
                    students={students}
                    setStudents={setStudents}
                />
            }
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

            <Button
                variant="contained"
                color="primary"
                sx={{ mr: 2 }}
                onClick={handleCreate}
                disabled={isCreating}
            >
                Finish
            </Button>
        </Box>
    );
};

export default ClassWizardEnd;
